import { BaseService } from './BaseService';
import { API_ENDPOINTS } from './config';
import {
  ArtifactProcess,
  ArtifactProcessCreate,
  ArtifactProcessUpdate,
} from '../../types/artifactProcess';

export class ArtifactProcessService extends BaseService {
  static async getAll(): Promise<ArtifactProcess[]> {
    return this.get<ArtifactProcess[]>(API_ENDPOINTS.ARTIFACT_PROCESSES.BASE);
  }

  static async getById(id: string): Promise<ArtifactProcess> {
    return this.get<ArtifactProcess>(API_ENDPOINTS.ARTIFACT_PROCESSES.BY_ID(id));
  }

  static async getByArtifactId(artifactId: string): Promise<ArtifactProcess[]> {
    return this.get<ArtifactProcess[]>(API_ENDPOINTS.ARTIFACT_PROCESSES.BY_ARTIFACT(artifactId));
  }

  static async create(data: ArtifactProcessCreate): Promise<ArtifactProcess> {
    return this.post<ArtifactProcess>(
      API_ENDPOINTS.ARTIFACT_PROCESSES.BASE,
      data as unknown as Record<string, unknown>
    );
  }

  static async update(id: string, data: ArtifactProcessUpdate): Promise<ArtifactProcess> {
    return this.put<ArtifactProcess>(
      API_ENDPOINTS.ARTIFACT_PROCESSES.BY_ID(id),
      data as unknown as Record<string, unknown>
    );
  }

  static async delete(id: string): Promise<void> {
    return this.delete(API_ENDPOINTS.ARTIFACT_PROCESSES.BY_ID(id));
  }

  static async searchByName(name: string): Promise<ArtifactProcess[]> {
    return this.get<ArtifactProcess[]>(API_ENDPOINTS.ARTIFACT_PROCESSES.SEARCH(name));
  }

  static async getCArtifacts(processId: string): Promise<ProcessCArtifact[]> {
    return this.get<ProcessCArtifact[]>(
      `${API_ENDPOINTS.ARTIFACT_PROCESSES.BY_ID(processId)}/c-artifacts`
    );
  }
}

export interface ProcessCArtifact {
  artifact_id: string;
  artifact_name: string;
  states: CArtifactState[];
  transitions: CArtifactTransition[];
}

export interface CArtifactState {
  id: string;
  name: string;
  description?: string;
  state_type: string;
  is_initial: boolean;
  is_final: boolean;
  is_required: boolean;
}

export interface CArtifactTransition {
  id: string;
  name: string;
  description?: string;
  transition_type: string;
  input_state_ref: string;
  output_state_ref: string;
  input_output_ratio: number;
  is_active: boolean;
  demand_type: string;
  demand_flow_type: string;
}
